function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { CONSOLE_LEVELS, GLOBAL_OBJ, fill, severityLevelFromString, safeJoin } from '@sentry/utils';
/** Send Console API calls as Sentry Events */

var CaptureConsole = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */
  function CaptureConsole() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CaptureConsole);

    ;

    CaptureConsole.prototype.__init.call(this);

    CaptureConsole.prototype.__init2.call(this);

    if (options.levels) {
      this._levels = options.levels;
    }
  }
  /**
   * @inheritDoc
   */


  _createClass(CaptureConsole, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = CaptureConsole.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "__init2",
    value: function __init2() {
      this._levels = CONSOLE_LEVELS;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (!('console' in GLOBAL_OBJ)) {
        return;
      }

      this._levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        if (!(level in GLOBAL_OBJ.console)) {
          return;
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access


        fill(GLOBAL_OBJ.console, level, function (originalConsoleMethod) {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var hub = getCurrentHub();

            if (hub.getIntegration(CaptureConsole)) {
              hub.withScope(function (scope) {
                scope.setLevel(severityLevelFromString(level));
                scope.setExtra('arguments', args);
                scope.addEventProcessor(function (event) {
                  event.logger = 'console';
                  return event;
                });
                var message = safeJoin(args, ' ');

                if (level === 'assert') {
                  if (args[0] === false) {
                    message = "Assertion failed: ".concat(safeJoin(args.slice(1), ' ') || 'console.assert');
                    scope.setExtra('arguments', args.slice(1));
                    hub.captureMessage(message);
                  }
                } else if (level === 'error' && args[0] instanceof Error) {
                  hub.captureException(args[0]);
                } else {
                  hub.captureMessage(message);
                }
              });
            } // this fails for some browsers. :(


            if (originalConsoleMethod) {
              originalConsoleMethod.apply(GLOBAL_OBJ.console, args);
            }
          };
        });
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'CaptureConsole';
    }
  }]);

  return CaptureConsole;
}();

CaptureConsole.__initStatic();

export { CaptureConsole };